<form [formGroup]="resetForm">
  <div class="c-reset-page" fxLayout="column" fxLayoutAlign="center center">
    <div class="c-login-logo">
      <img [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
    </div>
    <div class="c-status-message">
      <p
        *ngIf="isValidateError"
        class="u-background-color-error u-font-color-white u-padding-10 u-text-center"
      >
        {{validationMassage}}
      </p>
      <p
        *ngIf="isSuccess"
        class="u-background-color-success u-font-color-white u-padding-10 u-text-center "
      >
        {{ successMessage }}
        <button
          mat-button
          mat-flat-button
          color="primary"
          class="c-reset-button u-margin-top-5"
          routerLink="../../login"
        >
          {{ "reset_password.btn_login" | translate }}
        </button>
      </p>
    </div>
    <div class="c-reset-box">
      <mat-form-field class="mat-block" appearance="fill">
        <input
          matInput
          [placeholder]="'reset_password.text_password' | translate"
          formControlName="password"
          [type]="hide ? 'text' : 'password'"
          (keydown)="noWhiteSpaceAllow($event)"
          required
        />
        <mat-icon matSuffix (click)="hide = !hide">
          {{hide ? 'visibility' : 'visibility_off'}}</mat-icon
        >
        <mat-error
          id="matPasswordRequired"
          class="error-message"
          *ngIf="
          (resetForm.get('password').dirty ||
          resetForm.get('password').touched ) &&
          resetForm.get('password').hasError('required')
        "
        >
          {{ "reset_password.password_validation" | translate }}
        </mat-error>
        <mat-error
          id="matPasswordPattern"
          class="error-message"
          *ngIf="
          (resetForm.get('password').dirty ||
          resetForm.get('password').touched ) &&
          resetForm.get('password').hasError('pattern')
        "
        >
          {{ "reset_password.password_invalid" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-block" appearance="fill">
        <input
          matInput
          [placeholder]="'reset_password.text_confirm_password' | translate"
          formControlName="confirmPassword"
          [type]="chide ? 'text' : 'password'"
          required
        />
        <mat-icon matSuffix (click)="chide = !chide">
          {{chide ? 'visibility' : 'visibility_off'}}</mat-icon
        >
        <mat-error
          id="matConfirmPasswordRequired"
          class="error-message"
          *ngIf="(resetForm.get('confirmPassword').dirty ||
          resetForm.get('confirmPassword').touched )  &&
          resetForm.get('confirmPassword').hasError('required')
        "
        >
          {{ "reset_password.confirm_password_validation" | translate }}
        </mat-error>
        <mat-error
          id="matConfirmPasswordNotSame"
          class="error-message"
          *ngIf="resetForm.get('confirmPassword').hasError('notSame')"
        >
          {{ "reset_password.password_mismatch" | translate }}
        </mat-error>
      </mat-form-field>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-reset-button u-margin-top-5"
        [disabled]="resetForm.invalid"
        (click)="onSubmitResetPassword()"
      >
        {{ "reset_password.btn_reset" | translate }}
      </button>
      <button
        mat-button
        mat-flat-button
        color="warn"
        class="c-reset-button u-margin-top-5"
        (click)="onCancelResetPassword()"
      >
        {{ "reset_password.btn_cancel" | translate }}
      </button>
    </div>
  </div>
</form>
